/**
 * YouTube Video Autoplay on Scroll
 * Uses YouTube IFrame API and Intersection Observer
 */

const players = {};
const pendingPlay = new Set();

function onYouTubeIframeAPIReady() {
  console.log('[YouTube] IFrame API Ready (global callback)');
  window.initializeYouTubePlayers();
}

window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
window.initializeYouTubePlayers = initializeYouTubePlayers;

function initializeYouTubePlayers() {
  const videoIframes = document.querySelectorAll('.yt-video-autoplay');
  console.log('[YouTube] Scanning for iframes, found:', videoIframes.length);
  
  videoIframes.forEach((iframe) => {
    const videoId = iframe.id;
    if (!videoId) return;

    if (players[videoId]) {
      console.log('[YouTube] Already tracked:', videoId);
      return;
    }

    console.log('[YouTube] Initializing player object for:', videoId);
    
    // Start observing immediately, even before player is ready
    const container = iframe.closest('[data-video-container]');
    if (container) {
      setupIntersectionObserver(container, videoId);
    }

    try {
      players[videoId] = {
        instance: new YT.Player(videoId, {
          events: {
            'onReady': (event) => onPlayerReady(event, videoId),
            'onStateChange': (event) => onPlayerStateChange(event, videoId)
          }
        }),
        ready: false,
        inView: false
      };
    } catch (error) {
      console.error('[YouTube] YT.Player constructor error:', error);
    }
  });
}

function setupIntersectionObserver(container, videoId) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const playerObj = players[videoId];
      if (!playerObj) return;

      if (entry.isIntersecting) {
        console.log('[YouTube] Entering viewport:', videoId);
        playerObj.inView = true;
        
        if (playerObj.ready) {
          console.log('[YouTube] Playing (player ready):', videoId);
          playerObj.instance.playVideo();
        } else {
          pendingPlay.add(videoId);
          console.log('[YouTube] Pending play (waiting for ready):', videoId);
        }
        
        const unmuteBtn = container.querySelector('.video-unmute-btn');
        if (unmuteBtn) unmuteBtn.style.display = 'block';
      } else {
        console.log('[YouTube] Leaving viewport:', videoId);
        playerObj.inView = false;
        pendingPlay.delete(videoId);
        if (playerObj.ready) {
          playerObj.instance.pauseVideo();
        }
      }
    });
  }, { threshold: 0.15 }); // 15% visibility is enough to start

  observer.observe(container);
}

function onPlayerReady(event, videoId) {
  console.log('[YouTube] Player reported ready:', videoId);
  const playerObj = players[videoId];
  if (!playerObj) return;

  playerObj.ready = true;
  
  // Browsers require muted autoplay
  playerObj.instance.mute();

  // If already in view during the time it took to load, play now
  if (playerObj.inView || pendingPlay.has(videoId)) {
    console.log('[YouTube] Executing pending play after ready:', videoId);
    playerObj.instance.playVideo();
    pendingPlay.delete(videoId);
  }

  // Bind unmute button
  const iframe = playerObj.instance.getIframe();
  const container = iframe?.closest('[data-video-container]');
  const unmuteBtn = container?.querySelector('.video-unmute-btn');
  
  if (unmuteBtn && !unmuteBtn.dataset.listener) {
    unmuteBtn.addEventListener('click', function() {
      if (playerObj.instance.isMuted()) {
        playerObj.instance.unMute();
        this.textContent = '🔇 Tắt âm thanh';
        this.classList.add('active');
        console.log('[YouTube] Unmuted:', videoId);
      } else {
        playerObj.instance.mute();
        this.textContent = '🔊 Bật âm thanh';
        this.classList.remove('active');
        console.log('[YouTube] Muted:', videoId);
      }
    });
    unmuteBtn.dataset.listener = "true";
  }
}

function onPlayerStateChange(event, videoId) {
  const states = { '-1': 'unstarted', '0': 'ended', '1': 'playing', '2': 'paused', '3': 'buffering', '5': 'cued' };
  console.log('[YouTube] State update:', videoId, '->', states[event.data] || event.data);
}

function loadYouTubeAPI() {
  if (window.YT && window.YT.Player) {
    console.log('[YouTube] API already detected in window');
    initializeYouTubePlayers();
  } else if (!document.querySelector('script[src*="iframe_api"]')) {
    console.log('[YouTube] Injecting IFrame API script tag');
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }
}

// Kickstart
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadYouTubeAPI);
} else {
  loadYouTubeAPI();
}
